import BaseAppService from "application/platform/base-app.service";
import MunicipalPortalAAppService from "application/platform/municipal-portal-service";
import { ACTION_TYPES, useAppDispatch } from "./app-context";
import { IApplicationData } from "models/application-data";
import { IMenusListRequest } from "models/request/menus-list-request";
import { INewsPagedRequest } from "models/request/news-paged-request";
import { ILinkServicesListRequest } from "models/request/link-services-list-request";
import { IBannersListRequest } from "models/request/banners-list-request";

export const useAppController = () => {
    const AppDispatch = useAppDispatch();

    const getApplicationData = async (): Promise<IApplicationData | undefined> => {
        try {
            const applicationData = await BaseAppService.requestApplicationData();

            AppDispatch({
                type: ACTION_TYPES.setApplicationData,
                payload: applicationData,
            });

            BaseAppService.setApplicationData(applicationData);

            return applicationData;

        } catch (error) {
            console.log(error);

        }
    }

    const getMenus = async (multiTenantId: number): Promise<void> => {
        try {
            AppDispatch({
                type: ACTION_TYPES.setMenusLoading,
                payload: true,
            });

            const menus = await MunicipalPortalAAppService.listMenus();

            console.log('Menus carregados:', menus);

            // Se API retorna vazio, usar fallback
            if (!menus || menus.length === 0) {
                console.warn('No menus returned from API, using fallback nav-items');
                AppDispatch({
                    type: ACTION_TYPES.setMenus,
                    payload: [],
                });
                return;
            }

            AppDispatch({
                type: ACTION_TYPES.setMenus,
                payload: menus,
            });

        } catch (error) {
            console.error('Failed to fetch menus:', error);
            AppDispatch({
                type: ACTION_TYPES.setMenusError,
                payload: true,
            });
        }
    }

    const getHomeNews = async (count: number): Promise<void> => {
        try {
            const news = await MunicipalPortalAAppService.listNews({ page: 0, pageSize: count } as INewsPagedRequest);

            AppDispatch({
                type: ACTION_TYPES.setHomeNews,
                payload: news,
            });
        } catch (error) {
            console.error('Failed to fetch home news:', error);
        }
    }

    const getHomeLinkServices = async (count: number): Promise<void> => {
        try {
            const linkServices = await MunicipalPortalAAppService.listLinkServices({ count } as ILinkServicesListRequest);

            AppDispatch({
                type: ACTION_TYPES.setHomeLinkServices,
                payload: linkServices,
            });
        } catch (error) {
            console.error('Failed to fetch home link services:', error);
        }
    }

    const getHomeBanners = async (): Promise<void> => {
        try {
            const banners = await MunicipalPortalAAppService.listBanners({} as IBannersListRequest);

            AppDispatch({
                type: ACTION_TYPES.setHomeBanners,
                payload: banners,
            });
        } catch (error) {
            console.error('Failed to fetch home banners:', error);
        }
    }

    return {
        getApplicationData,
        getMenus,
        getHomeNews,
        getHomeLinkServices,
        getHomeBanners
    };
}